<template>
    <v-card tile class="pa-0" hover height="100%">
        <v-card-text class="text-center">
            <apexchart type="line" :height="height" :options="lineOptions" :series="series" />
        </v-card-text>
    </v-card>
</template>

<script>
    import apexchart from 'vue-apexcharts'

    export default {
        components: {
            apexchart
        },

        props: ['title', 'height', 'series', 'categories'],

        data() {
            return {
                lineOptions: {
                    chart: {
                        type: 'line',
                        fontFamily: 'Tajawal',
                        toolbar: {
                            show: true
                        },
                        zoom: {
                            enabled: false
                        },
                        tooltip: {
                            enable:false
                        }
                    },
                    title: {
                        text: this.title,
                        align: 'center',
                        margin: 5,
                        offsetX: 0,
                        offsetY: 0,
                        floating: false,
                        style: {
                            fontSize: '11px',
                            fontWeight: 'bold',
                            fontFamily: undefined,
                            color: '#263238',
                            maxWidth: '200px'
                        }
                    },
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        curve: 'smooth',
                        width: 2,
                        colors: ['#01579B']
                    },
                    xaxis: {
                        categories: this.categories,
                        labels: {
                            labels: this.categories,
                            show: true,
                            rotate: 20,
                            rotateAlways: false,
                            maxHeight: 100,
                            style: {
                                fontSize: '10px',
                                fontFamily: 'Tajawal',
                                fontWeight: '600'
                            }
                        },
                        tooltip: {
                            enabled: false
                        }
                    },
                    tooltip: {
                        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                            const labels = w.config.xaxis.labels.labels
                            if (seriesIndex !== 1 && labels && labels.length > dataPointIndex) {
                                const label = labels[dataPointIndex]
                                const value = series[seriesIndex][dataPointIndex]
                                return '<div style="padding:5px;font-weight:bold;color:white;background-color: #01579B;">' + label + ': ' + value + '</div>'
                            }
                            return ''
                        }.bind(this)
                    },
                    markers: {
                        size: 5,
                        colors: ['#01579B'],
                        strokeColors: ['#01579B'],
                        strokeWidth: 2 
                    },
                    colors: ['#01579B'],
                    fill: {
                        type: 'solid',
                        colors: ['#01579B'],
                        opacity: 1
                    },
                }

            }
        }
    }
</script>

<style>
    .apexcharts-legend-text {
        padding: 0 5px !important;
    }

    .apexcharts-toolbar {
        top: -17px !important;
        right: -20px !important;
    }
</style>
